import React from 'react'
import { node, string } from 'prop-types'
import styled, { css } from 'styled-components'
import { rgba, stripUnit } from 'polished'

import { green, grey, red } from 'styles/colors'
import { borderRadius } from 'styles/global'
import * as spacing from 'styles/spacing'

const Container = styled.div`
  display: inline-block;
  background-color: ${rgba(grey, 0.1)};
  color: ${grey};
  border-radius: ${borderRadius};
  padding: ${stripUnit(spacing.small) * 1.5 + 'px'} ${spacing.medium};

  ${props =>
    props.type === 'success' &&
    css`
      background-color: ${rgba(green, 0.1)};
      color: ${green};
    `}

  ${props =>
    props.type === 'error' &&
    css`
      background-color: ${rgba(red, 0.1)};
      color: ${red};
    `}
`

const FormFeedback = ({ type, children }) => (
  <Container type={type}>
    <p>{children}</p>
  </Container>
)

FormFeedback.propTypes = {
  children: node,
  type: string
}

export default FormFeedback
